export default "__VITE_ASSET__WpmWga3Y__"